module.exports = __webpack_public_path__ + "img/banner_4.513bf813.png";